import { IFollowupAdmin } from "@interfaces/screens/followup-admin.interface";
import { BasePresenter } from "@presenters/base/base.presenter";
import { useSelector } from "react-redux";
import { IFollowup, ILang,  } from "@models/*";
import { Constants, Dictionary, moment, Utilities, Enums } from "@utils";
import {  FollowupService, IFollowupService } from "@services/proyecta/followup.service";
import DataGrid from "devextreme/ui/data_grid";
export class FollowupAdminPresenter extends BasePresenter<IFollowupAdmin> {
    public currentLabels: Dictionary<string, string>;
    public followupLabels: Dictionary<string, string>;
    public formMasters: any;
    public followupData: IFollowup[];
    public subProjectDimensions: any[];
    public subProjectMonths: any[];
    public subProjectPeriods: any[];
    public currentLang: ILang;
    public params: any;
    private followupService: IFollowupService;
 
    constructor(view: IFollowupAdmin) {
        super(view);
        this.params = useSelector(this.context.sessionStore.selectParams);
        this.followupData = useSelector(this.context.followupStore.selectFollowupData);
        this.subProjectDimensions = useSelector(this.context.followupStore.selectSubProjectDimensions);
        this.subProjectMonths = useSelector(this.context.followupStore.selectSubProjectMonths);
        this.subProjectPeriods = useSelector(this.context.followupStore.selectSubProjectPeriods);
        this.formMasters = useSelector(this.context.followupStore.selectFormMasters);
        this.currentLabels = useSelector(this.context.sessionStore.selectLabels);
        this.followupLabels = useSelector(this.context.followupStore.selectLabels);
        this.currentLang = useSelector(this.context.sessionStore.selectLang) as any;

        this.onProjectChanged = this.onProjectChanged.bind(this);
        this.onSubProjectChanged = this.onSubProjectChanged.bind(this);
        this.onYearChange = this.onYearChange.bind(this);
        this.onYearMassiveChange = this.onYearMassiveChange.bind(this);
        this.onDimensionChanged = this.onDimensionChanged.bind(this);
        this.onHidingToast = this.onHidingToast.bind(this);
        this.onCellClick = this.onCellClick.bind(this);
        this.followupService = new FollowupService();
    }
    
    public async initialize(reload?: boolean){ 
        if (reload) {
            this.dispatcherProgress(30);
            this.dispatcherPendingLoad(1);
            this.dispatcherSetLoading();
        }

        this.dispatcherProgress(50);   
        this.dispatcher(this.context.followupStore.getFollowupData()); 
        this.dispatcherProgress(80); 

        if(!reload){
            this.dispatcher(this.context.followupStore.getLabels());
            this.dispatcher(this.context.followupStore.getAllFormMasters()); 
            const columns = await this.followupService.getDefinitionColumnsAdmin(this.currentLang.id);
            this.view.state.setDataColumns(columns);
        }
        
        this.dispatcherUnsetSetLoading();
    }
   
    public getData(followData: IFollowup[], masters: any){
        let newData: any[] = []  
        
        for (const data of followData) {
            let idsFinancers = data.IdFinanciador?.split(", ")
            let findSubCode = null
            if(!!idsFinancers) findSubCode = idsFinancers.map((y: any) => masters.allFinancers.find((x: any) => x.Id === Number(y))?.Title).join(", ")
            let country = !!data.IdPais 
                ? masters.countries.find((x: any) => x.Id === Number(data.IdPais))?.Title 
                : masters.regions.find((x: any) => x.Id === Number(data.IdRegion))?.Title || ''
            let intLine = masters.interventionLines.find((x: any) => x.Id === Number(data.IdLineaIntervencion))

            newData.push({
                id: data.Id,
                project: `${data.PPresCodProy || ''} - ${data.TituloProyecto || ''}`, 
                subProject: `${data.CodigoSubvencion || this.followupLabels.get("subprojectFFRR")} - ${findSubCode || ''}`, 
                year: data.Anio,
                allow: Number(data.EstadoAnio),
                country,
                intLineCode: intLine?.OCTAVIACodigo || '',
                intLinetitle: intLine?.Title || '',
                status: Number(data.EstadoSubproyecto),
                startDate: moment.utc(new Date(data.OCTAVIAFechaInicio)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY"),
                endDate: moment.utc(new Date(data.OCTAVIAFechaFinalizacion)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY"),
                projectId: data.IdProyecto,
                subvCode: data.CodigoSubvencion || '',
                financer: findSubCode || ''
            })
        }   

        this.view.state.setFollowData(newData);
    }

    public getMassiveData(followData: IFollowup[], subProjectDimensions: any){
        let dataYears: any[] = []
        let auxDimensions: any[] = []
        const monthsEn = Constants.Months.English
        let defaultNextClose = this.params[Enums.Params.nextClosingMassiveInitial] || Enums.FollowupState.january
        let defaultNextCloseId = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === defaultNextClose)?.Id
        const stateEdit = this.formMasters?.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.edit)?.Id

        let indicators = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.indicators)
        let beneficiaries = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.beneficiaries)
        let financial = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.financial)
        let dimensions = [indicators, beneficiaries, financial]

        for (const data of followData) {
            let year: number = Number(data.Anio)
            let allow: number = Number(data.EstadoAnio)
            let dataExist = dataYears.find((x: any) => x.year === year)
            if(!dataExist && isFinite(year)){
                dataYears.push({year, allow})
                auxDimensions.push(
                    ...dimensions.map((dim: any) => {
                        let minNextClose = defaultNextCloseId
                        let minMonth: number = null
                        for (const subPr of subProjectDimensions) {
                            if(subPr.SubProyectoAnio?.Anio === year.toString() && subPr.DimensionId === dim?.Id){
                                let num = Number(moment.utc(new Date(subPr.ProximoCierre)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY").split('-')[1])-1
                                if(Utilities.isNullObject(minMonth) || num < minMonth) minMonth = num
                            }
                        }
                        
                        if(!Utilities.isNullObject(minMonth)){
                            minNextClose = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === (monthsEn[minMonth] || defaultNextClose))?.Id
                        }

                        return {
                            year,
                            dimension: dim?.Title,
                            dimensionId: dim?.Id,
                            nextClosing: Number(minNextClose)
                        }
                    })
                )
            }else if(!!dataExist){
                if(dataExist.allow !== stateEdit && allow === stateEdit) dataExist.allow = allow
            }
        }   
        dataYears = dataYears.sort((a: any, b: any) => ((a.year < b.year) ? -1 : ((a.year > b.year) ? 1 : 0)))

        return {dataYears, auxDimensions}
    }

    public getActualDimension(year: number, dimensionsData: any){
        return dimensionsData.filter((x: any) => x.year === year)
    }

    public async saveMassiveData(){
        this.dispatcherProgress(0);
        this.dispatcherPendingLoad(1);
        this.dispatcherSetLoading();
        this.dispatcherProgress(20);

        let currUser = this.currentUser.currentUser.userPrincipalName
        let followData = Utilities.copyObject(this.followupData) || []
        let subProjectDimensions = Utilities.copyObject(this.subProjectDimensions) || []
        let itemsToUpd: any[] = []
        let dimToUpd: any[] = []

        if(this.view.state.years?.length){
            for (const item of this.view.state.years) {
                if(item.change){
                    let auxItems = followData.filter((x: any) => {
                        if(x.Anio === item.year.toString()){
                            x.EstadoAnio = item.allow.toString()
                            return x;
                        }
                    })
                    itemsToUpd = [...itemsToUpd, ...auxItems]
                    item.change = false
                }
            }
        }
        if(this.view.state.dimensionsData?.length){
            for (const item of this.view.state.dimensionsData) {
                if(item.change){
                    let month = this.getMonthIndex(this.formMasters.followupState.find((x: any) => x.Id === item.nextClosing)?.OCTAVIACodigo) + 1
                    let ProximoCierre = month + '/01/' + item.year
                    let auxItems = subProjectDimensions.filter((x: any) => {
                        if(x.SubProyectoAnio?.Anio === item.year.toString() && x.DimensionId === item.dimensionId){
                            x.ProximoCierre = ProximoCierre
                            return x;
                        }
                    })
                    dimToUpd = [...dimToUpd, ...auxItems]
                    item.change = false
                }
            }
        }

        this.dispatcherProgress(40);
        await Promise.all([
            this.followupService.updateIndexFollowup(itemsToUpd, Enums.ListTypes.IndexFollowup, currUser), 
            this.followupService.updateIndexFollowup(dimToUpd, Enums.ListTypes.SeguimientoEstadoSubproyectoDimensiones),
        ]);

        Utilities.notifySuccess(this.currentLabels.get("Guardado exitoso"), this.currentLabels.get("Guardar"))
            .then(( )=> { this.initialize(true) })
    }

    public async saveData(){
        this.dispatcherProgress(0);
        this.dispatcherPendingLoad(1);
        this.dispatcherSetLoading();
        this.dispatcherProgress(50);
        
        let itemsFollowupToUpdate: any[] = []
        let itemsSubprToUpdate: any[] = []
        let itemsSubprToCreate: any[] = []
        let monthsSubprToUpdate: any[] = []
        let monthsSubprToCreate: any[] = []
        let periodsSubprToUpdate: any[] = []
        let periodsSubprToCreate: any[] = []
       
        if(!!this.view.state.subProjectSelected){
            let followData = Utilities.copyObject(this.followupData)
            let subProject = this.view.state.subProjectSelected

            let info = this.getDataFromTable(`${subProject.projectId}-${subProject.id}-admin-subprojects`);

            for (let newInfo of info) {
                let actualInfo = followData.find((x: any) => x.Id === newInfo.id)
                actualInfo.EstadoSubproyecto = this.view.state.stateSubProject.toString()
                actualInfo.EstadoAnio = newInfo.allow.toString()
                itemsFollowupToUpdate.push(actualInfo)
            }
        }
        if(!!this.view.state.yearsData){
            let yearsData = this.view.state.yearsData
            let actualYear = this.view.state.yearSelected?.year || new Date().getFullYear()
            let subProjectDimensions = Utilities.copyObject(this.subProjectDimensions)
            let reportId = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.narrativeReport)?.Id

            for (let dimUpdate of yearsData) {
                for (let newInfo of dimUpdate) {
                    let ProximoCierre = null, UltimoCierre = null
                    let actualSubPr = subProjectDimensions.find((x: any) => x.Id === newInfo.id)
                    if(reportId !== newInfo.dimensionId){
                        let lastClosingIndex = this.getMonthIndex(this.formMasters.followupState.find((x: any) => x.Id === newInfo.lastClosing)?.OCTAVIACodigo) + 1
                        let nextClosingIndex = this.getMonthIndex(this.formMasters.followupState.find((x: any) => x.Id === newInfo.nextClosing)?.OCTAVIACodigo) + 1
                        ProximoCierre =  nextClosingIndex + '/01/' + actualYear
                        UltimoCierre = lastClosingIndex + '/01/' + actualYear
                    }

                    if(!!actualSubPr){
                        actualSubPr.EstadoDimension = newInfo?.state?.toString()
                        actualSubPr.ProximoCierre = ProximoCierre
                        actualSubPr.UltimoCierre = UltimoCierre
                        actualSubPr.EnEdicion = false
                        itemsSubprToUpdate.push(actualSubPr)
                    }else{
                        let DimensionId = this.formMasters.followupDimensions.find((x: any) => [x.Title, x.OCTAVIANombreEn, x.OCTAVIANombrePT, x.OCTAVIANombreFR].includes(newInfo.dimension))?.Id
                        let createSubPr = {
                            EstadoDimension: newInfo?.state?.toString(),
                            DimensionId, 
                            SubProyectoAnioId: newInfo.subProyectoAnio,
                            ProximoCierre: ProximoCierre,
                            UltimoCierre: UltimoCierre,
                            EnEdicion: false
                        }
                        itemsSubprToCreate.push(createSubPr)
                    }
                }
            }
        }
        if(!!this.view.state.monthsData){
            let monthsData = this.view.state.monthsData
            let subProjectMonths = Utilities.copyObject(this.subProjectMonths)
            for (const auxData of monthsData) {
                if(!auxData[0].isPeriod){
                    let actualSubPrMonths = subProjectMonths.find((x: any) => x.SubProyectoAnioId === auxData[0].SubProyectoAnioId && auxData[0].DimensionId === x.DimensionId)
                    let newObj: any = {
                        DimensionId: actualSubPrMonths?.DimensionId || auxData[0].DimensionId,
                        SubProyectoAnioId: actualSubPrMonths?.SubProyectoAnioId || this.view.state.dimensionSelected.subProyectoAnio,
                        EneroEstado: auxData[0]?.monthState.toString(),
                        FebreroEstado: auxData[1]?.monthState.toString(),
                        MarzoEstado: auxData[2]?.monthState.toString(),
                        AbrilEstado: auxData[3]?.monthState.toString(),
                        MayoEstado: auxData[4]?.monthState.toString(),
                        JunioEstado: auxData[5]?.monthState.toString(),
                        JulioEstado: auxData[6]?.monthState.toString(),
                        AgostoEstado: auxData[7]?.monthState.toString(),
                        SeptiembreEstado: auxData[8]?.monthState.toString(),
                        OctubreEstado: auxData[9]?.monthState.toString(),
                        NoviembreEstado: auxData[10]?.monthState.toString(),
                        DiciembreEstado: auxData[11]?.monthState.toString(),
                    }

                    if(!!actualSubPrMonths){
                        newObj.Id = actualSubPrMonths.Id
                        monthsSubprToUpdate.push(newObj)
                    }else{
                        monthsSubprToCreate.push(newObj)
                    }
                }else{
                    let subProjectPeriods = Utilities.copyObject(this.subProjectPeriods)
                    for (const period of auxData) {
                        
                        let actualSubPrPeriods = subProjectPeriods.find((x: any) => x.SubProyectoAnioId === period.SubProyectoAnioId && period.DimensionId === x.DimensionId && period.periodId === x.SeguimientoPeriodosId)
                        if(!!actualSubPrPeriods){
                            actualSubPrPeriods.EstadoPeriodo = period.monthState.toString()
                            periodsSubprToUpdate.push(actualSubPrPeriods)
                        }else{
                            let newPeriod = {
                                SeguimientoPeriodosId: period.periodId,
                                DimensionId: period.DimensionId,
                                SubProyectoAnioId: this.view.state.dimensionSelected.subProyectoAnio,
                                EstadoPeriodo: period.monthState.toString()
                            }
                            periodsSubprToCreate.push(newPeriod)
                        }
                    }
                }
            }
        }

        let currUser = this.currentUser.currentUser.userPrincipalName

        await Promise.all([
            
            this.followupService.updateIndexFollowup(itemsFollowupToUpdate, Enums.ListTypes.IndexFollowup, currUser), 
            this.followupService.addIndexFollowup(itemsSubprToCreate, Enums.ListTypes.SeguimientoEstadoSubproyectoDimensiones),
            this.followupService.updateIndexFollowup(itemsSubprToUpdate, Enums.ListTypes.SeguimientoEstadoSubproyectoDimensiones),
            this.followupService.addIndexFollowup(monthsSubprToCreate, Enums.ListTypes.SeguimientoEstadoSubproyectoMeses),
            this.followupService.updateIndexFollowup(monthsSubprToUpdate, Enums.ListTypes.SeguimientoEstadoSubproyectoMeses),
            this.followupService.addIndexFollowup(periodsSubprToCreate, Enums.ListTypes.SeguimientoEstadoSubproyectoPeriodos),
            this.followupService.updateIndexFollowup(periodsSubprToUpdate, Enums.ListTypes.SeguimientoEstadoSubproyectoPeriodos)
        ]);

        this.view.state.setHasChanged(false)

        Utilities.notifySuccess(this.currentLabels.get("Guardado exitoso"), this.currentLabels.get("Guardar"))
            .then(( )=> { this.initialize(true) })
    }

    public getAdminPermissions(){
        const ADMIN_GROUP = this.params?.[Enums.Params.proyectaAdminModule]
        let userGroups: any[] = this?.currentUser?.userGroups?.map((x: any) => x.displayName)

        return (userGroups?.includes(ADMIN_GROUP))
    }

    public getUserPermissions(){
        return (this?.currentUser?.currentUser?.userPrincipalName === "syntax@ayudaenaccion.org")
    }

    public getCommonFieldProps(fieldName: string, dimension?: any) {
        const fieldProps = this.view.state.dataColumns.get(fieldName);
        const field: any = {
          id: `${fieldProps?.Id || 0}_followupAdmin`,
          caption: fieldProps?.OCTAVIAValorTraduccion || "",
          dataField: fieldProps?.Title || "",
          dataType: fieldProps?.OCTAVIATipoCampo || "string",
          allowEditing: !fieldProps?.SoloLectura,
          alignment: fieldProps?.Alineacion || "center"
        };

        if(fieldName === Enums.FollowupBasicFields.allow){
            field.lookup = { 
                dataSource: [
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.view), 
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.edit)
                ], displayExpr: "Title", valueExpr: "ID"
            }
        }
        if(fieldName === Enums.FollowupBasicFields.state){
            let Planning = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.planning)
            let Followup = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.followup)
            let Modifications = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.substantialModifications)
            let dataSource = [Planning, Modifications, Followup]
            
            field.lookup = { dataSource, displayExpr: "Title", valueExpr: "ID" }
        }
        if(fieldName === Enums.FollowupBasicFields.nextClosing || fieldName === Enums.FollowupBasicFields.lastClosing){
            field.lookup = { 
                dataSource: [
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.january),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.february),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.march),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.april),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.may),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.june),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.july),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.august),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.september),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.october),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.november),
                    this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.december)
                ],
                displayExpr: "Title", valueExpr: "ID"
            }
        }
        if(fieldName === Enums.FollowupBasicFields.monthState){
            let Followup = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.followup)
            let report = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.narrativeReport)?.Id
            field.allowEditing = (dimension?.state === Followup?.Id || dimension?.dimensionId === report) 
            field.lookup = { 
                dataSource: (dimension?.dimensionId === report) 
                    ? [
                        this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.presented),
                        this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.approved),
                        this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.process),
                        this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.suspended)
                    ] 
                    : [
                        this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.monthOpen), 
                        this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.monthClosed)
                    ],
                displayExpr: "Title", valueExpr: "ID"
            }
        }
        
        return field;
    }

    public getSubprojectsGrids(): any {
        let internalProps: any = {
            editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
            rowAlternationEnabled:false,
            onToolbarPreparing: (e:any) => {                                    
                e.toolbarOptions.items.unshift({
                location: 'before',
                template: `<h6 style="color:rgb(240, 53, 0)">${this.followupLabels.get('adminSubProjects')}</h6>`
                })
            },
            selection:{
                mode:"single",
                showCheckBoxesMode: "none"
            },
            onRowUpdated: () => { this.view.state.setHasChanged(true) },
            onSelectionChanged: this.onYearChange
        }

        return internalProps;
    }

    public getMassiveProcessGrids(): any {
        let internalProps: any = {
            editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
            rowAlternationEnabled:false,
            onToolbarPreparing: (e:any) => {                                    
                e.toolbarOptions.items.unshift({
                location: 'before',
                template: `<h6 style="color:rgb(240, 53, 0)">${this.followupLabels.get('adminSubProjects')}</h6>`
                })
            },
            selection:{
                mode:"single",
                showCheckBoxesMode: "none"
            },
            onRowUpdated: (e: any) => { 
                if(e?.data) e.data.change = true
            },
            onSelectionChanged: this.onYearMassiveChange
        }

        return internalProps;
    }

    public getMassiveDimensionsGrids(): any {
        let internalProps: any = {
            editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
            rowAlternationEnabled:false,
            onToolbarPreparing: (e:any) => {                                    
                e.toolbarOptions.items.unshift({
                location: 'before',
                template: `<h6 style="color:rgb(240, 53, 0)">${this.followupLabels.get("dimensions")}</h6>`
                })
            },
            selection:{
                mode:"single",
                showCheckBoxesMode: "none"
            },
            onRowUpdated: (e: any) => { 
                if(e?.data) e.data.change = true
            },
        }

        return internalProps;
    }

    public getDimensionsGrids(): any {
        let internalProps: any = {
            editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
            rowAlternationEnabled:false,
            onToolbarPreparing: (e:any) => {                                    
                e.toolbarOptions.items.unshift({
                location: 'before',
                template: `<h6 style="color:rgb(240, 53, 0)">${this.followupLabels.get("dimensions")}</h6>`
                })
            },
            selection:{
                mode:"single",
                showCheckBoxesMode: "none"
            },
            onRowUpdated: () => { this.view.state.setHasChanged(true) },
            onSelectionChanged: this.onDimensionChanged,
        }

        return internalProps;
    }

    public getDimensionsMonthsGrids(): any {
        let internalProps: any = {
            editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
            rowAlternationEnabled:false,
            onToolbarPreparing: (e:any) => {                                    
                e.toolbarOptions.items.unshift({
                location: 'before',
                template: '<h6 style="color:rgb(240, 53, 0)">'+this.view.state.dimensionSelected.dimension+'</h6>'
                })
            },
            selection:{
                mode:"single",
                showCheckBoxesMode: "none"
            },
            onRowUpdated: () => { this.view.state.setHasChanged(true) },
        }

        return internalProps;
    }

    public onProjectChanged(e:any){ 
        const data = this.view.state.followData.filter((item:any) => item.project === e.value);
        const auxArray: string[]= [];
        const subData: any = [];
        data.forEach((item:any) => {
            if(!auxArray.includes(item.subProject)){
                auxArray.push(item.subProject);
                subData.push(item);
            }
        });
        this.view.state.setSubProjects(subData);
        this.view.state.setProjectSelected(e.value);
        this.view.state.setSubProjectSelected(null);
        this.clear()

        if(this.view.state.projectSelected && this.view.state.hasChanged) {
            this.setToastMessage()
            this.view.state.setHasChanged(false)
        }
    }

    public getDisplayExpression(item:any){
        if(item === undefined) return "..."
        return item.subProject;
    }

    public onHidingToast(){
		this.view.state.setToastConfig({
			...this.view.state.toastConfig,
			isVisible: false,
		});
	};

    public getSubProjectsColumns(){
        return [
            this.getCommonFieldProps("year"),
            this.getCommonFieldProps("allow")
        ]
    }

    public getDimensionsColumns(){
        return [
            this.getCommonFieldProps("dimension"),
            this.getCommonFieldProps("state", this.view.state.dimensionSelected),
            this.getCommonFieldProps("lastClosing"),
            this.getCommonFieldProps("nextClosing")
        ]
    }

    public getMassiveDimensionsColumns(){
        return [
            this.getCommonFieldProps("dimension"),
            this.getCommonFieldProps("nextClosing"),
        ]
    }

    public getDimensionsMonthsColumns(){
        return [
            this.getCommonFieldProps("month"),
            this.getCommonFieldProps("monthState", this.view.state.dimensionSelected),
        ]
    }

    public getSubprojectsStateItems(){
		return [
            this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.valid), 
            this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.closed)
        ]
	};

    public onSubProjectChanged(e:any){   
        const data = this.view.state.followData.filter((item:any) => item.subProject === e.value.subProject && item.project === this.view.state.projectSelected);
        
        data.sort((a: any, b: any) => (Number(a.year) > Number(b.year)) ? 1 : -1)

        this.view.state.setSubProjectData(data);
        this.view.state.setSubProjectSelected(e.value);
        this.view.state.setStateSubProject(data[0]?.status)
        this.clear()

        if(this.view.state.subProjectSelected && this.view.state.hasChanged) {
            this.setToastMessage()
            this.view.state.setHasChanged(false)
        }
    }

    public onCellClick(e: any): any {
        let reportId = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.narrativeReport)?.Id
        if(e.column.dataField === Enums.FollowupBasicFields.state){
            let Planning = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.planning)
            let Followup = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.followup)
            let Modifications = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.substantialModifications)
            if(e.value === Planning.Id) e.column.lookup.dataSource = [Planning, Modifications]
            else if(e.value === Followup.Id) e.column.lookup.dataSource = [Followup, Planning, Modifications]
            else if(e.data.dimensionId === reportId)e.column.lookup.dataSource = []
            else e.column.lookup.dataSource = [Modifications]
        }
        if(e.data.dimensionId === reportId){
            const element = e.row.cells[1].cellElement;     
            element.style.pointerEvents = "none";
        }
    }

    private clear(){   
        this.view.state.setdimensionSelected(null);
        this.view.state.setYearSelected(null);
        this.view.state.setMonthData([]);
        this.view.state.setMonthsData([]);
        this.view.state.setYearsData([]);
        this.view.state.setDimensionData([]);
    }

    public onYearMassiveChange(e: any){
        if(e.selectedRowsData.length){
            this.view.state.setYearSelected(e.currentSelectedRowKeys[0]);
        }        
    }

    private onYearChange(e:any){
        if(e.selectedRowsData.length){
            let defaultState = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.planning)?.Id
            const data: any[] = []
            for (const item of this.subProjectDimensions) {
                if(item.SubProyectoAnioId === e.selectedRowsData[0].id){
                    data.push({
                        id: item.Id,
                        dimension: item.DimensionId,
                        state: item.EstadoDimension,
                        lastClosing: moment.utc(new Date(item.UltimoCierre)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY").substr(3,2),
                        nextClosing: moment.utc(new Date(item.ProximoCierre)).tz(Constants.GeneralFormats.TIME_ZONE).format("DD-MM-YYYY").substr(3,2),
                        subProyectoAnio: e.selectedRowsData[0].id,
                    })
                }
            }

            let indicators = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.indicators)
            let beneficiaries = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.beneficiaries)
            let financial = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.financial)
            let narrativeReport = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.narrativeReport)

            const pivotData = [
                {
                    id: data?.find((x: any) => x.dimension === indicators?.Id)?.id,
                    dimension: indicators?.Title,
                    dimensionId: indicators?.Id,
                    state: Number(data?.find((x: any) => x.dimension === indicators?.Id)?.state) || defaultState,
                    lastClosing: this.getMonthId(data?.find((x: any) => x.dimension === indicators?.Id)?.lastClosing || 1),
                    nextClosing: this.getMonthId(data?.find((x: any) => x.dimension === indicators?.Id)?.nextClosing || 1),
                    subProyectoAnio: e.selectedRowsData[0].id,
                },
                {
                    id: data?.find((x: any) => x.dimension === beneficiaries?.Id)?.id,
                    dimension: beneficiaries?.Title,
                    dimensionId: beneficiaries?.Id,
                    state: Number(data?.find((x: any) => x.dimension === beneficiaries?.Id)?.state) || defaultState,
                    lastClosing: this.getMonthId(data?.find((x: any) => x.dimension === beneficiaries?.Id)?.lastClosing || 1),
                    nextClosing: this.getMonthId(data?.find((x: any) => x.dimension === beneficiaries?.Id)?.nextClosing || 1),
                    subProyectoAnio: e.selectedRowsData[0].id,
                },
                {
                    id: data?.find((x: any) => x.dimension === financial?.Id)?.id,
                    dimension: financial?.Title,
                    dimensionId: financial?.Id,
                    state: Number(data?.find((x: any) => x.dimension === financial?.Id)?.state) || defaultState,
                    lastClosing: this.getMonthId(data?.find((x: any) => x.dimension === financial?.Id)?.lastClosing || 1),
                    nextClosing: this.getMonthId(data?.find((x: any) => x.dimension === financial?.Id)?.nextClosing || 1),
                    subProyectoAnio: e.selectedRowsData[0].id,
                },
                {
                    id: data?.find((x: any) => x.dimension === narrativeReport?.Id)?.id,
                    dimension: narrativeReport?.Title,
                    dimensionId: narrativeReport?.Id,
                    subProyectoAnio: e.selectedRowsData[0].id,
                }
            ];
            let dataExist = this.view.state.yearsData?.find((x: any) => x[0].dimensionId === pivotData[0].dimensionId && x[0].subProyectoAnio === pivotData[0].subProyectoAnio)

            if(!dataExist) this.view.state.setYearsData([...this.view.state.yearsData, pivotData]);
            this.view.state.setYearSelected(e.selectedRowsData[0]);
            this.view.state.setDimensionData(!!dataExist ? dataExist : pivotData);
            this.view.state.setdimensionSelected(null);
        }
    }

    private onDimensionChanged(e:any){
        if(e.selectedRowsData.length){
            const selectedItem = e.selectedRowsData[0];
            let subPrMonths = this.subProjectMonths.find((x: any) => x.DimensionId === selectedItem.dimensionId && x.SubProyectoAnioId === selectedItem.subProyectoAnio)
            let PlanningId = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.planning)?.Id

            let narrativeReport = this.formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.narrativeReport)?.Title
            const monthsSP = Constants.Months.Spanish
            const months = [
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.january)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.february)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.march)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.april)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.may)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.june)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.july)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.august)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.september)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.october)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.november)?.Title,
                this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.december)?.Title,
            ];
            const data: any = [];
            if(selectedItem.dimension !== narrativeReport){   
                let defaultMonth = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.monthOpen)?.Id        
                months.forEach((item: string, index:number) => {
                    const newItem: any = {};            
                    newItem.month = item;
                    newItem.DimensionId = selectedItem.dimensionId;
                    newItem.SubProyectoAnioId = selectedItem.subProyectoAnio;
                    newItem.monthState = !!subPrMonths ? Number(subPrMonths[monthsSP[index] + 'Estado']) || defaultMonth : defaultMonth 
                    data.push(newItem);
                });            
            }else{
                let yearPeriods = this.formMasters.inPeriods?.filter((x: any) => x.Anio === this.view.state.yearSelected?.year) || []
                let defaultReport = this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === Enums.FollowupState.suspended)?.Id
                for (const yp of yearPeriods) {
                    let dataSaved = this.subProjectPeriods.find((x: any) => x.SubProyectoAnioId === selectedItem.subProyectoAnio && x.SeguimientoPeriodosId === yp.Id)

                    data.push({
                        month: yp.Title, 
                        periodId: yp.Id,
                        DimensionId: selectedItem.dimensionId, 
                        SubProyectoAnioId: selectedItem.subProyectoAnio, 
                        monthState: !!dataSaved ? Number(dataSaved.EstadoPeriodo) || defaultReport : defaultReport,
                        relatedId: dataSaved?.Id,
                        isPeriod: true
                    });
                }
            }
            this.view.state.setdimensionSelected(selectedItem);

            let dataExist = this.view.state.monthsData?.find((x: any) => x[0]?.DimensionId === selectedItem.dimensionId && x[0]?.SubProyectoAnioId === selectedItem.subProyectoAnio)
            this.view.state.setMonthData(!!dataExist ? dataExist : data);

            if(!dataExist && data?.length) this.view.state.setMonthsData([...this.view.state.monthsData, data]);
        }
    }

    private getDataFromTable(tableId: string): Array<any> {  
        let element = document.getElementById(tableId);
        if (Utilities.isNullEmptyObject(element)) {
          return [];
        }
    
        let instance = DataGrid.getInstance(element) as DataGrid;
            return instance.getDataSource().items();
    }

    private setToastMessage(){
        this.view.state.setToastConfig({
            isVisible: true,
            type: 'info',
            message: this.followupLabels.get("toastFollowupAdmin")
        });
    }

    private getMonthId(index: number | string){
        const months = Constants.Months.English;
        const i = Number(index) - 1;
        return  this.formMasters.followupState.find((x: any) => x.OCTAVIACodigo === months[i]).Id;
    }

    private getMonthIndex(name: string){
        const months = Constants.Months.English;
        return  months.indexOf(name);
    }
}

export default FollowupAdminPresenter;
